import { render, staticRenderFns } from "./applyHaoka2.vue?vue&type=template&id=33be06fa&scoped=true&"
import script from "./applyHaoka2.vue?vue&type=script&lang=js&"
export * from "./applyHaoka2.vue?vue&type=script&lang=js&"
import style0 from "./applyHaoka2.vue?vue&type=style&index=0&id=33be06fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be06fa",
  null
  
)

export default component.exports